import React from 'react'

import s from './styles.module.scss'

import { TagAutonomousBooking } from '../../atoms'
import { HouseContext } from '../../../lib/graphql'

const HouseCardGeoTitle = ({
  house,
}: {
  house: Pick<
    HouseContext,
    | 'address'
    | 'readableId'
    | 'title'
    | 'status'
    | 'isAutonomousBookingAvailable'
  >
}) => {
  return (
    <>
      <div className={s.geolocation}>
        <span>
          {house?.address?.department &&
            house?.address?.region &&
            `${house?.address?.department}, ${house?.address?.region}`}
        </span>
        <span className={s.readableId}>{house?.readableId}</span>
      </div>
      <div className={s.titleContainer}>
        <h1 className={s.titleHouse}>{house.title}</h1>
        {house.isAutonomousBookingAvailable && <TagAutonomousBooking />}
      </div>
    </>
  )
}

export default HouseCardGeoTitle
